module.exports = __webpack_public_path__ + "static/media/rainscreen.f11dccff.mp4";